// metal skin type
export const METAL_TYPE = {
    DEFAULT: "metal",
    LITE: "metal_lite",
    PRO: "metal_pro"
};

export const METAL_FEATURES = {
    ROTATE: {
        RIGHT: "right",
        LEFT: "left",
        DEGREE: 90
    },
    SIGNATURE: {
        TYPE: {
            ORIGINAL: "original",
            OPTIMISED: "optimised"
        }
    }
};



// todo all the common const for metal will be here